import Vue from "vue";

import App from "./components/app/app";
import setup from "./setup";
import acl from "./acl";

import * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

const { router, store, i18n } = setup();

require("./assets/main.scss");

// TODO: remove global jquery
window.$ = require("jquery");

Vue.use(AmplifyModules, AmplifyPlugin);

new Vue({
  i18n,
  router,
  store,
  acl,
  components: { App },
  template: "<App />"
}).$mount("#app");
